export const _statusColors = {
    completed: { value: "Completed", color: "#A5D6A7" },
    open: { value: "Open", color: "#90CAF9" },
    closed: { value: "Closed", color: "#E0E0E0" },
    inReview: { value: "In Review", color: "#FFE082" },
    revertToApplicant: { value: "Reverted to applicant", color: "#FFAB91" },
    sendEmailToEmployer: { value: "Email sent to employer", color: "#C5CAE9" },
    discrepancy: { value: "Discrepancy", color: "#EF9A9A" },
    onEmailRequest: { value: "Request sent for verification", color: "#EF9A9A" },
    onEmailResponse: { value: "Response received", color: "#EF9A9A" },
    "un-verified": { value: "Un Verified", color: "#F48FB1" },
}